import { classNames } from "../UI/Utils/classNames.ts";
import { UserActivePlans } from "./useUserActivePlans.ts";

function ActivePlanBadge({
  label,
  title,
  colorClassName,
}: {
  label: string;
  title: string;
  colorClassName: string;
}) {
  return (
    <span
      title={title}
      className={classNames(
        "inline-flex w-fit items-center rounded-md px-1.5 py-0.5 text-xs font-medium whitespace-nowrap",
        colorClassName,
      )}
    >
      {label}
    </span>
  );
}

export function ActivePlanBadges({
  activePlans,
}: {
  activePlans: UserActivePlans;
}) {
  return (
    <>
      {activePlans.hasActiveOneOnOnePlan && (
        <ActivePlanBadge
          label={"1TO1"}
          title={"Active 1TO1 plan"}
          colorClassName={"bg-violet-100 text-violet-800"}
        />
      )}
      {activePlans.hasActiveGroupPlan && (
        <ActivePlanBadge
          label={"Group"}
          title={"Active group plan"}
          colorClassName={"bg-sky-100 text-sky-800"}
        />
      )}
    </>
  );
}
